import React, { ReactNode, forwardRef } from 'react';
import cn from 'classnames';
import { Typography } from '@v2/ui';

type InputWithLabelProps = {
  icon: React.ReactNode;
  label: string;
  value: string | ReactNode | undefined;
  triggerClassName?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const InputWithLabel = forwardRef<
  HTMLButtonElement,
  InputWithLabelProps
>((props, ref) => {
  const { icon, label, value, triggerClassName, ...rest } = props;

  return (
    <button
      {...rest}
      ref={ref}
      type="button"
      className={cn(
        'group relative inline-flex cursor-pointer items-center justify-start gap-x-3.5 rounded-xl border border-gray-300 bg-white text-gray-800 transition-colors hover:border-gray-400',
        'h-16 w-full min-w-0 px-4 focus-visible:border-gray-800 focus-visible:outline-none lg:flex-1',
        triggerClassName
      )}
    >
      {icon}
      <div className="flex min-w-0 flex-col items-start justify-start gap-y-1">
        <Typography
          size="tsm"
          variant="span"
          className="font-medium text-gray-500"
        >
          {label}
        </Typography>
        <Typography
          size="tmd"
          variant="h3"
          className="w-full truncate text-sm font-semibold"
          suppressHydrationWarning
        >
          {value || ''}
        </Typography>
      </div>
    </button>
  );
});
